import { createTrackerInitializePerfume } from './performanceTracker'

createTrackerInitializePerfume()
